// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mAb4","col":"styles_col__3hEH1"};